import './components.scss';

const PageText = (props) => {
    return (
      <div className="pageText">
        {props.children}
      </div>
    )
  }

  export default PageText;